import {threeDotsIfLongerThan} from "../string/string";

export const getMetaTitleFixed = (str) => {
  return threeDotsIfLongerThan(150, str);
};

export const getMetaDescriptionFixed = (str) => {
  return threeDotsIfLongerThan(150, str);
};

/**
 * @typedef {Object} ItemMetaData
 * @property {string} keyPropKey
 * @property {string} keyPropValue
 * @property {string} key
 * @property {string} value
 */

/**
 * @typedef {ItemMetaData[]} MetaData
 */

/**
 * @params {string} keyPropKey
 * @params {string} keyPropValue
 * @params {string} key
 * @params {string} value
 * @returns {ItemMetaData}
 * @private
 */
const _makeItemMetaData = (keyPropKey, keyPropValue, key, value) => {
  return {
    keyPropKey,
    keyPropValue,
    key,
    value,
  };
};

export const makeItemMetaDataDefault = (key, value) => {
  return _makeItemMetaData("name", "content", key, value);
};

export const makeItemMetaDataOpenGraph = (key, value) => {
  return _makeItemMetaData("property", "content", "og:" + key, value);
};

export const makeItemMetaDataTwitter = (key, value) => {
  return _makeItemMetaData("name", "content", "twitter:" + key, value);
};
